import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    copyText: String,
    copiedText: String,
  };
  static targets = ["copiable", "copyTextContainer"];

  async copyToClipboard() {
    try {
      await navigator.clipboard.writeText(this.copiableTarget.innerText);
      this.copyTextContainerTarget.innerText = this.copiedTextValue;
    } catch (err) {
      console.error("Failed to copy content:", err);
    }
  }
}
